// Imports
import React, { useEffect, useState } from 'react';
// Contents
import { l } from '../../lang';
import { supabase } from '../../utils/supabase.js';

export default function PageHero({ lang }) {
    const [contentMap, setContentMap] = useState(null);

    useEffect(() => {
        supabase.from('menu_content').select('fr, en').eq('key', 'about').single()
            .then(({ data }) => { if (data) setContentMap(data); });
    }, []);

    const title = contentMap?.[lang] || l('about', lang);

    return (
        <div key={lang} className='section section-page-hero'>
            <div className='page-hero'>
                <div className='page-hero-content'>
                    <h1 className="h1">{title}</h1>
                </div>
            </div>
        </div>
    )
}
